var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "ushrUserSelectANSI",
        "content-class": "generic-release-modal ansi-user-select",
        size: "sm",
        "hide-footer": "",
        centered: "",
      },
      on: { show: _vm.handleShow, hide: _vm.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                { staticClass: "grm-header d-flex align-items-center w-100" },
                [
                  _c("div", { staticClass: "grm-header-text" }, [
                    _c("h5", { staticClass: "grm-title mb-0" }, [
                      _vm._v("Select a Customer"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "grm-subtitle mb-0" }, [
                      _vm._v("ANSI"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grm-header-badge ml-auto" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.customers.length) +
                        " available\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("fa", {
                    staticClass: "dataset-close-btn",
                    attrs: { icon: ["fas", "times"] },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "usc-list" },
        [
          _vm._l(_vm.customers, function (c) {
            return _c(
              "div",
              {
                key: c.id,
                staticClass: "usc-item",
                on: {
                  click: function ($event) {
                    return _vm.ushrUserAnsiChange(c)
                  },
                },
              },
              [
                _c("div", { staticClass: "usc-avatar" }, [
                  _vm._v(_vm._s(c.name.charAt(0).toUpperCase())),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "usc-name" }, [
                  _vm._v(_vm._s(c.name.substring(0, c.name.length - 4))),
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "usc-arrow",
                    attrs: { viewBox: "0 0 16 16", fill: "none" },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M3 8h10M9 4l4 4-4 4",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _vm.customers.length === 0
            ? _c("div", { staticClass: "usc-empty" }, [
                _vm._v("No customers available"),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }